export default __webpack_public_path__ + "static/media/gallery30.b51fc451.jpg";